import styled from 'styled-components';

interface RightLinkProps {
  active?: boolean;
}

export const RightLink = styled.div<RightLinkProps>`
  a {
    ${({ active }) => (!active ? 'opacity: .6;' : '')}
    font-family: ${({ theme }) => theme.fonts.secondary};
    color: ${({ theme }) => theme.colors.black[300]};
    margin-right: 1rem;
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 2rem;
  }
`;
